module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av193-99dbb351235b911cb346b27b240fb69f.jpg";